<template>
    <div class="layout"></div>
</template>

<style scoped>
    .layout{
        background: url('~@/assets/images/content/layout-zenit.jpg') no-repeat center top;
        height: 4971px;
    }
</style>